import React from 'react';
import { useDispatch } from 'react-redux';

const CheckboxFilter = ({ title, my_task, onChange }) => {
    const dispatch = useDispatch();
    return (
        <label className="cont">
            {title}
            <input
                checked={my_task}
                onChange={onChange}
                type="checkbox"
            />
            <span className="checkmark"/>
        </label>
    );
};

export default CheckboxFilter;
